import "./index.scss"
export default function NoMathPage() {
  return <div className="no-match">这里什么都没有</div>
}
